import * as Yup from "yup";

export function sanitizeClientContactNumber(value: string): string {
  return value.replace(/\D/g, "").slice(0, 15);
}

export const clientContactNumberSchema = Yup.string()
  .required("Client Contact Number is required")
  .matches(/^\d+$/, "Contact number must contain digits only")
  .min(7, "Contact number must be at least 7 digits")
  .max(15, "Contact number cannot exceed 15 digits");
